<template>
    <div class="about">
        <section class="page-banner"></section>

        <article class="mainwrap">
            <div class="maincon">
                <h1 class="custom-headline">
                    <span class="custom-headline-inner">About Us</span>
                </h1>

                <div class="skin-1">
                    <h3 class="h3"><strong>International Business Growth Professionals</strong></h3>
                    <p class="info-txt">For any business looking to grow and succeed in our fast-paced world, the implementation of a strategic business process is crucial.Delta Consulting Services is a boutique Asia based business growth consulting company providing private and public sector clients with the full suite of consulting services to accelerate growth, build brand value, and achieve market differentiation. We specialise in creating and implementing practical strategies that can offer organisations the highest impact on their business.</p>

                    <p class="info-txt">Our business consulting helps our clients accelerate, optimise and transform their organisations using leading business strategies and digital solutions. Asia clients can leverage from our international business expertise gained working with some of the largest companies and government departments around the world.</p>

                    <p class="info-txt">For any questions, queries or to set up a meeting with one of our Asia-based management consultants call +886277292428 or send email to info@delta-intltd.com, we would love to have you on board with us</p>
                </div>
                
                <ul class="skincon flex-wrap-between-top">
                    <li class="list-item">
                        <div class="conwrap">
                            
                        </div>
                    </li>
                    <li class="list-item">
                        <div class="conwrap">
                            
                        </div>
                    </li>
                </ul>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    name: 'About',
}
</script>

<style lang="less">
.about{
    .maincon{padding: 1px 0 20px;}
    .page-banner{height: 243.45px;background-image: url('//growth-s3.s3.ap-southeast-1.amazonaws.com/about/banner.jpg');}
    .skin-1{
        .h3{font-size: 37px;margin-bottom: 23px;}
        .info-txt{color: #848484;margin-bottom: 23px;font-size: 18px;}
    }
    .skincon{
        &{padding-top: 23px;}
        .list-item{width: calc(50% - 8px);}
        @media (max-width: 500px){
            .list-item{width: 100%;}
        }
    }
}
</style>